module.exports = __webpack_public_path__ + "img/심재성.67830b09.jpg";